import type { BulkApplicationResult } from "@app/shared";

// 一括申込(F-06b)の「選択企業」と「結果」を sessionStorage に保持する（§4.3）。
// - 選択: 検索条件変更・ページ送り・詳細モーダル・リロードで消えないため。
// - 結果: リロードで再表示するため（再POSTで復元しない＝ゾンビ再申込を作らない・A-3）。
// タブを閉じると消える（成立分は申込一覧で確認できる・仕様どおり）。

const SELECTION_KEY = "bulk-selection-v1";
const RESULT_KEY = "bulk-result-v1";

export interface SelectedCompany {
  id: string;
  name: string;
  jobTypes: string[];
}

export function loadSelection(): SelectedCompany[] {
  try {
    const s = sessionStorage.getItem(SELECTION_KEY);
    return s ? (JSON.parse(s) as SelectedCompany[]) : [];
  } catch {
    return [];
  }
}

export function saveSelection(list: SelectedCompany[]): void {
  try {
    sessionStorage.setItem(SELECTION_KEY, JSON.stringify(list));
  } catch {
    /* sessionStorage 不可の環境では選択保持を諦める（機能自体は動く） */
  }
}

export function clearSelection(): void {
  try {
    sessionStorage.removeItem(SELECTION_KEY);
  } catch {
    /* ignore */
  }
}

export function loadBulkResult(): BulkApplicationResult | null {
  try {
    const s = sessionStorage.getItem(RESULT_KEY);
    return s ? (JSON.parse(s) as BulkApplicationResult) : null;
  } catch {
    return null;
  }
}

export function saveBulkResult(r: BulkApplicationResult): void {
  try {
    sessionStorage.setItem(RESULT_KEY, JSON.stringify(r));
  } catch {
    /* ignore */
  }
}

export function clearBulkResult(): void {
  try {
    sessionStorage.removeItem(RESULT_KEY);
  } catch {
    /* ignore */
  }
}
